__turbopack_context__.v({
  "centerBlockImageContainer": "block-module-scss-module__TmH8fW__centerBlockImageContainer",
  "image": "block-module-scss-module__TmH8fW__image",
  "imageContainer": "block-module-scss-module__TmH8fW__imageContainer",
  "item": "block-module-scss-module__TmH8fW__item",
  "subtitle": "block-module-scss-module__TmH8fW__subtitle",
  "title": "block-module-scss-module__TmH8fW__title",
});
